const riot = require('riot');

riot.tag2('modal-record-edit', '<div ref="modal"> <div ref="edit" data-is="module-record-edit" item="{opts.item}"></div> </div>', 'modal-record-edit,[data-is="modal-record-edit"]{background-color:rgba(0,0,0,0.5)}', 'class="f fh s-full"', function(opts) {
    this.on('mount', () => {
      this.refs.edit.on('submit', (data) => {
        this.trigger('submit', data);
        this.close();
      });

      this.refs.edit.on('delete', () => {
        this.trigger('delete');
        this.close();
      });
    });
});